import get from 'lodash.get';
import type { ThemeProps } from '../../types/shared';
import type { SpacingVars } from '../../types/theme';

export const getResponsiveSpacing =
  /* eslint-disable @typescript-eslint/no-redundant-type-constituents */

  (size: keyof SpacingVars | string = '') =>
    (styledComponentProps: ThemeProps): string => {
      const spacing = get(styledComponentProps, `theme.responsive.spacing.${size.toLowerCase()}`);
      if (spacing) return `var(${spacing as string})`;

      const fallbackSpacing = get(styledComponentProps, `theme.spacing.${size.toLowerCase()}`);
      if (fallbackSpacing) return `var(${fallbackSpacing as string})`;

      return '';
    };
